import React from 'react';
import styles from './KeyFeatureProduct.module.css';
import athleteImage from '../assets/Feature2.jpg';

const KeyFeatureProduct = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Key Features</h2>
      <p className={styles.subtitle}>
        Revolutionizing Athlete Performance with Smart Timing & Jump Assessments
      </p>
      <div className={styles.content}>
        <div className={styles.imageWrapper}>
          <img src={athleteImage} alt="Athlete running" className={styles.athleteImage} />
        </div>
        <div className={styles.featuresList}>
          <div className={styles.featureItem}>
            <svg className={styles.checkmarkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2L3.5 7.5V16.5L12 22L20.5 16.5V7.5L12 2Z"
                stroke="#B3B3B3"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M7 12L10 15L17 8"
                stroke="#B3B3B3"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p>
              Speed Measurement – Perfect for sprints, acceleration tests, and split-time tracking.
            </p>
          </div>
          <div className={styles.featureItem}>
            <svg className={styles.checkmarkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2L3.5 7.5V16.5L12 22L20.5 16.5V7.5L12 2Z"
                stroke="#B3B3B3"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M7 12L10 15L17 8"
                stroke="#B3B3B3"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p>
              Agility Testing – Measure quick direction changes in shuttle runs, zigzags, and more.
            </p>
          </div>
          <div className={styles.featureItem}>
            <svg className={styles.checkmarkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2L3.5 7.5V16.5L12 22L20.5 16.5V7.5L12 2Z"
                stroke="#B3B3B3"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M7 12L10 15L17 8"
                stroke="#B3B3B3"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p>
              Reaction Time Analysis – Train reflexes with visual/auditory start signals.
            </p>
          </div>
          <div className={styles.featureItem}>
            <svg className={styles.checkmarkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2L3.5 7.5V16.5L12 22L20.5 16.5V7.5L12 2Z"
                stroke="#B3B3B3"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M7 12L10 15L17 8"
                stroke="#B3B3B3"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p>
              Jump Height Detection: Calculate vertical height and flight time for your jumps for sports like Track & Field, Basketball & Volleyball
            </p>
          </div>
          <div className={styles.featureItem}>
            <svg className={styles.checkmarkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2L3.5 7.5V16.5L12 22L20.5 16.5V7.5L12 2Z"
                stroke="#B3B3B3"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M7 12L10 15L17 8"
                stroke="#B3B3B3"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p>
              Multi-Gate Synchronization – Seamless RF connectivity between Master and Slave Gates for complex drills.
            </p>
          </div>
          <div className={styles.featureItem}>
            <svg className={styles.checkmarkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2L3.5 7.5V16.5L12 22L20.5 16.5V7.5L12 2Z"
                stroke="#B3B3B3"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M7 12L10 15L17 8"
                stroke="#B3B3B3"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p>
              Multi-Gate Synchronization – Seamless RF connectivity between Master and Slave Gates for complex drills.

            </p>
          </div>
        </div>
      </div>

    </div>

  );
};

export default KeyFeatureProduct;